import { useState, useEffect } from "react";

const CookieBanner = ({ instanceId }: { instanceId?: string }) => {
	const [showBanner, setShowBanner] = useState(false);

	useEffect(() => {
		const consent = localStorage.getItem(`cookieConsent_${instanceId}`);
		if (!consent) {
			setShowBanner(true);
		} else {
			setShowBanner(false);
		}
	}, [instanceId]);

	const handleAccept = () => {
		localStorage.setItem(`cookieConsent_${instanceId}`, 'true');
		setShowBanner(false);
	};

	return (
		showBanner && (
			<div className='fixed bottom-0 left-0 right-0 flex items-center justify-between p-4 text-white bg-gray-900'>
				<p className='text-sm'>This website uses cookies to enhance your experience. Some cookies are set by Intercom, our customer support chat provider, to improve interactions and store session information. By continuing, you agree to our use of cookies.</p>
				<button
					className='px-4 py-2 text-white bg-blue-500 rounded'
					onClick={handleAccept}>
					Accept
				</button>
			</div>
		)
	);
};

export default CookieBanner;
